import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useStoreValue } from '@portal/state/hooks/useStore';
import { storeCodeSchema } from '@portal/schema/storeCode';

declare global {
  interface Window {
    $superfiliateStorefront?: {
      sdk: {
        handlePageView: () => void;
      };
    };
  }
}

export default function useSuperfiliate() {
  const router = useRouter();
  const store = useStoreValue();
  useEffect(() => {
    // Only track Superfiliate for US store
    if (store !== storeCodeSchema.enum.us) {
      return;
    }

    function handleRouteComplete() {
      if (window.$superfiliateStorefront?.sdk) {
        window.$superfiliateStorefront.sdk.handlePageView();
      }
    }

    handleRouteComplete();
    router.events.on('routeChangeComplete', handleRouteComplete);

    return () => {
      router.events.off('routeChangeComplete', handleRouteComplete);
    };
  }, [router.events, store]);
}
